export const CUSTOMER_CSV_HEADERS = [
  'nombre',
  'telefono',
  'email',
  'cuit',
  'direccion',
  'categoria_fiscal',
  'notas',
  'dias_pago',
] as const;

export const CUSTOMER_CSV_REQUIRED_HEADERS = ['nombre'] as const;

export function customerCsvTemplateFilename(): string {
  return 'plantilla_clientes.csv';
}

export function customerCsvExportFilename(): string {
  return `clientes_${new Date().toISOString().slice(0, 10)}.csv`;
}
